// 由 pb-proto 生成（just gen-ts），不要手改。
export const PRESET_ACTIONS: ReadonlyArray<{ id: number; name: string; category: string; label: string }> = [
  {
    "category": "initial_pose",
    "id": 100,
    "label": "恢复初始姿态",
    "name": "INITIAL_POSE"
  },
  {
    "category": "wave",
    "id": 1001,
    "label": "右手挥手",
    "name": "RIGHT_ARM_WAVE"
  },
  {
    "category": "wave",
    "id": 1003,
    "label": "右手挥手（远距）",
    "name": "RIGHT_ARM_WAVE_FAR"
  },
  {
    "category": "wave",
    "id": 1011,
    "label": "左手挥手",
    "name": "LEFT_ARM_WAVE"
  },
  {
    "category": "wave",
    "id": 1013,
    "label": "左手挥手（远距）",
    "name": "LEFT_ARM_WAVE_FAR"
  },
  {
    "category": "wave",
    "id": 2002,
    "label": "双手喜悦挥动",
    "name": "BOTH_HANDS_HAPPY_WAVE"
  },
  {
    "category": "wave",
    "id": 3043,
    "label": "双手挥舞",
    "name": "BOTH_HANDS_WAVE"
  },
  {
    "category": "wave",
    "id": 3045,
    "label": "双手挥舞 2",
    "name": "BOTH_HANDS_WAVE_2"
  },
  {
    "category": "wave",
    "id": 3046,
    "label": "双手挥舞 3",
    "name": "BOTH_HANDS_WAVE_3"
  },
  {
    "category": "wave",
    "id": 3047,
    "label": "左右手挥舞",
    "name": "LEFT_RIGHT_WAVE"
  },
  {
    "category": "handshake",
    "id": 1002,
    "label": "右手握手",
    "name": "RIGHT_ARM_HANDSHAKE"
  },
  {
    "category": "handshake",
    "id": 1012,
    "label": "左手握手",
    "name": "LEFT_ARM_HANDSHAKE"
  },
  {
    "category": "fist_bump",
    "id": 1004,
    "label": "右手碰拳",
    "name": "RIGHT_ARM_FIST_BUMP"
  },
  {
    "category": "fist_bump",
    "id": 1014,
    "label": "左手碰拳",
    "name": "LEFT_ARM_FIST_BUMP"
  },
  {
    "category": "cheer",
    "id": 1005,
    "label": "右手加油欢呼",
    "name": "RIGHT_ARM_CHEER"
  },
  {
    "category": "cheer",
    "id": 1015,
    "label": "左手加油欢呼",
    "name": "LEFT_ARM_CHEER"
  },
  {
    "category": "cheer",
    "id": 2016,
    "label": "双手加油欢呼 / 舞蹈 1",
    "name": "BOTH_HANDS_CHEER_DANCE_1"
  },
  {
    "category": "cheer",
    "id": 3040,
    "label": "双手欢呼",
    "name": "BOTH_HANDS_CHEER"
  },
  {
    "category": "cheer",
    "id": 3048,
    "label": "双手欢呼 1",
    "name": "BOTH_HANDS_CHEER_1"
  },
  {
    "category": "cheer",
    "id": 3054,
    "label": "双手欢呼 2",
    "name": "BOTH_HANDS_CHEER_2"
  },
  {
    "category": "cheer",
    "id": 3055,
    "label": "双手欢呼 3",
    "name": "BOTH_HANDS_CHEER_3"
  },
  {
    "category": "photo",
    "id": 1006,
    "label": "右手持摄像杆",
    "name": "RIGHT_ARM_HOLD_CAMERA_POLE"
  },
  {
    "category": "photo",
    "id": 1007,
    "label": "右手拍照抬起",
    "name": "RIGHT_ARM_PHOTO_RAISE"
  },
  {
    "category": "photo",
    "id": 2011,
    "label": "拍照动作 1",
    "name": "PHOTO_POSE_1"
  },
  {
    "category": "photo",
    "id": 2012,
    "label": "拍照动作 2",
    "name": "PHOTO_POSE_2"
  },
  {
    "category": "photo",
    "id": 2013,
    "label": "拍照动作 3",
    "name": "PHOTO_POSE_3"
  },
  {
    "category": "photo",
    "id": 2014,
    "label": "拍照动作 4",
    "name": "PHOTO_POSE_4"
  },
  {
    "category": "photo",
    "id": 2020,
    "label": "三连拍",
    "name": "PHOTO_THREE_SHOT"
  },
  {
    "category": "raise",
    "id": 1016,
    "label": "左手抬起",
    "name": "LEFT_ARM_RAISE"
  },
  {
    "category": "raise",
    "id": 2015,
    "label": "双手抬起",
    "name": "BOTH_HANDS_RAISE"
  },
  {
    "category": "heart",
    "id": 2001,
    "label": "双手比心",
    "name": "BOTH_HANDS_MAKE_HEART"
  },
  {
    "category": "talk",
    "id": 2003,
    "label": "说话动作",
    "name": "BOTH_HANDS_TALKING"
  },
  {
    "category": "talk",
    "id": 2004,
    "label": "说话动作 1",
    "name": "TALK_1"
  },
  {
    "category": "talk",
    "id": 2005,
    "label": "说话动作 2",
    "name": "TALK_2"
  },
  {
    "category": "talk",
    "id": 2006,
    "label": "说话动作 3",
    "name": "TALK_3"
  },
  {
    "category": "talk",
    "id": 2007,
    "label": "说话动作 4",
    "name": "TALK_4"
  },
  {
    "category": "talk",
    "id": 2008,
    "label": "说话动作 5",
    "name": "TALK_5"
  },
  {
    "category": "talk",
    "id": 2009,
    "label": "说话动作 6",
    "name": "TALK_6"
  },
  {
    "category": "talk",
    "id": 2024,
    "label": "小幅度说话",
    "name": "TALK_SMALL"
  },
  {
    "category": "pride",
    "id": 2017,
    "label": "骄傲",
    "name": "PRIDE"
  },
  {
    "category": "dance",
    "id": 2021,
    "label": "跳舞动作",
    "name": "DANCE_MOVE"
  },
  {
    "category": "dance",
    "id": 2022,
    "label": "蛇形舞动 1",
    "name": "SNAKE_DANCE_1"
  },
  {
    "category": "dance",
    "id": 2023,
    "label": "蛇形舞动 2+3",
    "name": "SNAKE_DANCE_2_3"
  },
  {
    "category": "dance",
    "id": 2042,
    "label": "破冰舞蹈",
    "name": "ICEBREAKER_DANCE"
  },
  {
    "category": "dance",
    "id": 2043,
    "label": "蛇形舞动 2（导演剪辑）",
    "name": "SNAKE_DANCE_2_DIRECTOR"
  },
  {
    "category": "dance",
    "id": 2044,
    "label": "跳舞动作（更新版）",
    "name": "DANCE_MOVE_UPDATED"
  },
  {
    "category": "dance",
    "id": 3061,
    "label": "全身跳舞 2",
    "name": "FULL_BODY_DANCE_2"
  },
  {
    "category": "show_off",
    "id": 2025,
    "label": "人形炫耀（仅上肢）",
    "name": "HUMANOID_SHOW_OFF_UPPER"
  },
  {
    "category": "show_off",
    "id": 2027,
    "label": "人形炫耀（带腰部）",
    "name": "HUMANOID_SHOW_OFF_WAIST"
  },
  {
    "category": "show_off",
    "id": 2028,
    "label": "人形炫耀（腰部明显）",
    "name": "HUMANOID_SHOW_OFF_WAIST_STRONG"
  },
  {
    "category": "skate",
    "id": 2029,
    "label": "人形滑冰（30s）",
    "name": "HUMANOID_SKATE_30S"
  },
  {
    "category": "skate",
    "id": 2030,
    "label": "人形滑冰（备用）",
    "name": "HUMANOID_SKATE_BACKUP"
  },
  {
    "category": "rhythm",
    "id": 2031,
    "label": "人形律动",
    "name": "HUMANOID_RHYTHM"
  },
  {
    "category": "emote",
    "id": 2032,
    "label": "人形喜悦",
    "name": "HUMANOID_HAPPY"
  },
  {
    "category": "emote",
    "id": 2033,
    "label": "人形难过",
    "name": "HUMANOID_SAD"
  },
  {
    "category": "emote",
    "id": 2034,
    "label": "人形害怕",
    "name": "HUMANOID_SCARED"
  },
  {
    "category": "think",
    "id": 2035,
    "label": "人形思考 1",
    "name": "HUMANOID_THINK_1"
  },
  {
    "category": "think",
    "id": 2036,
    "label": "人形思考 2",
    "name": "HUMANOID_THINK_2"
  },
  {
    "category": "think",
    "id": 2037,
    "label": "人形思考 3",
    "name": "HUMANOID_THINK_3"
  },
  {
    "category": "think",
    "id": 2038,
    "label": "人形思考 4",
    "name": "HUMANOID_THINK_4"
  },
  {
    "category": "turn",
    "id": 2039,
    "label": "人形转圈 90°",
    "name": "HUMANOID_TURN_90"
  },
  {
    "category": "turn",
    "id": 2040,
    "label": "人形转圈 360°",
    "name": "HUMANOID_TURN_360"
  },
  {
    "category": "listen",
    "id": 2041,
    "label": "人形聆听",
    "name": "HUMANOID_LISTEN"
  },
  {
    "category": "hug",
    "id": 2026,
    "label": "人形拥抱",
    "name": "HUMANOID_HUG"
  },
  {
    "category": "high_five",
    "id": 3038,
    "label": "单臂击掌",
    "name": "SINGLE_ARM_HIGH_FIVE"
  },
  {
    "category": "greeting",
    "id": 3052,
    "label": "打招呼",
    "name": "GREETING"
  },
  {
    "category": "greeting",
    "id": 3056,
    "label": "打招呼 2",
    "name": "GREETING_2"
  },
  {
    "category": "hold_arm",
    "id": 3062,
    "label": "保持手臂动作 1",
    "name": "HOLD_ARM_MOVE_1"
  },
  {
    "category": "hold_arm",
    "id": 3064,
    "label": "保持手臂动作 2",
    "name": "HOLD_ARM_MOVE_2"
  },
  {
    "category": "hold_arm",
    "id": 3065,
    "label": "保持手臂动作 3",
    "name": "HOLD_ARM_MOVE_3"
  }
];
export const SAFE_ACTIONS: ReadonlyArray<string> = [
  "wave",
  "handshake",
  "heart",
  "talk",
  "listen",
  "think",
  "greeting",
  "hug"
];
export const RISKY_ACTIONS: ReadonlyArray<string> = [
  "fist_bump",
  "cheer",
  "photo",
  "raise",
  "pride",
  "dance",
  "show_off",
  "skate",
  "rhythm",
  "emote",
  "turn",
  "high_five",
  "hold_arm"
];
export const ALWAYS_ALLOWED_PRESETS: ReadonlyArray<number> = [
  100
];
/** 全部运动模式（来自固件 McAction.idl）；`remote_safe` = 远程可切换的目标 */
export const MODES: ReadonlyArray<{ name: string; id: number; label: string; remote_safe: boolean }> = [
  {
    "id": 1,
    "label": "被动（卸力）",
    "name": "PASSIVE_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 2,
    "label": "阻尼",
    "name": "DAMPING_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 3,
    "label": "四足躺下",
    "name": "QUAD_LIE_DOWN",
    "remote_safe": false
  },
  {
    "id": 10,
    "label": "四足变双足",
    "name": "QUADRUPED_TO_BIPED",
    "remote_safe": false
  },
  {
    "id": 11,
    "label": "四足变双足（旋转）",
    "name": "QUADRUPED_TO_BIPED_ROTATE",
    "remote_safe": false
  },
  {
    "id": 12,
    "label": "四足变双足（前空翻）",
    "name": "QUADRUPED_TO_BIPED_FRONTFLIP",
    "remote_safe": false
  },
  {
    "id": 20,
    "label": "双足变四足",
    "name": "BIPED_TO_QUADRUPED",
    "remote_safe": false
  },
  {
    "id": 21,
    "label": "双足变四足（旋转）",
    "name": "BIPED_TO_QUADRUPED_ROTATE",
    "remote_safe": false
  },
  {
    "id": 22,
    "label": "双足变四足（前空翻）",
    "name": "BIPED_TO_QUADRUPED_FRONTFLIP",
    "remote_safe": false
  },
  {
    "id": 100,
    "label": "四足倒地起身",
    "name": "QUADRUPED_RECOVERY",
    "remote_safe": false
  },
  {
    "id": 101,
    "label": "四足站立",
    "name": "QUADRUPED_STAND_DEFAULT",
    "remote_safe": true
  },
  {
    "id": 102,
    "label": "四足行走",
    "name": "QUADRUPED_LOCOMOTION_DEFAULT",
    "remote_safe": true
  },
  {
    "id": 112,
    "label": "四足奔跑",
    "name": "QUADRUPED_LOCOMOTION_RUN",
    "remote_safe": false
  },
  {
    "id": 103,
    "label": "四足越障",
    "name": "QUADRUPED_LOCOMOTION_TERRAIN",
    "remote_safe": false
  },
  {
    "id": 104,
    "label": "四足仿生",
    "name": "QUADRUPED_LOCOMOTION_BIONIC",
    "remote_safe": false
  },
  {
    "id": 105,
    "label": "四足前空翻",
    "name": "QUADRUPED_LOCOMOTION_FRONTFLIP",
    "remote_safe": false
  },
  {
    "id": 106,
    "label": "四足后空翻",
    "name": "QUADRUPED_LOCOMOTION_BACKFLIP",
    "remote_safe": false
  },
  {
    "id": 107,
    "label": "四足握手",
    "name": "QUADRUPED_LOCOMOTION_HANDSHAKE",
    "remote_safe": false
  },
  {
    "id": 108,
    "label": "四足坐下",
    "name": "QUADRUPED_LOCOMOTION_SIT",
    "remote_safe": false
  },
  {
    "id": 109,
    "label": "四足跳舞",
    "name": "QUADRUPED_LOCOMOTION_DANCE",
    "remote_safe": false
  },
  {
    "id": 110,
    "label": "四足趴下",
    "name": "QUADRUPED_GET_DOWN_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 111,
    "label": "四足坐下",
    "name": "QUADRUPED_SIT_DOWN_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 113,
    "label": "四足骄傲",
    "name": "QUADRUPED_LOCOMOTION_PRIDE",
    "remote_safe": false
  },
  {
    "id": 114,
    "label": "四足愉快",
    "name": "QUADRUPED_LOCOMOTION_PLEASURE",
    "remote_safe": false
  },
  {
    "id": 115,
    "label": "四足准备站立",
    "name": "QUADRUPED_READY_STAND_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 116,
    "label": "四足跳跃",
    "name": "QUADRUPED_LOCOMOTION_JUMP",
    "remote_safe": false
  },
  {
    "id": 117,
    "label": "四足伸展",
    "name": "QUADRUPED_LOCOMOTION_STRETCH",
    "remote_safe": false
  },
  {
    "id": 118,
    "label": "四足俯卧撑",
    "name": "QUADRUPED_PUSH_UP",
    "remote_safe": false
  },
  {
    "id": 119,
    "label": "四足模仿",
    "name": "QUADRUPED_MIMIC",
    "remote_safe": false
  },
  {
    "id": 120,
    "label": "四足蜷缩",
    "name": "QUADRUPED_CROUCH_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 121,
    "label": "四足踏步",
    "name": "QUADRUPED_LOCOMOTION_STEP",
    "remote_safe": false
  },
  {
    "id": 122,
    "label": "QUADRUPED_STAND_REVERSE_DEFAULT",
    "name": "QUADRUPED_STAND_REVERSE_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 123,
    "label": "QUADRUPED_LOCOMOTION_REVERSE_DEFAULT",
    "name": "QUADRUPED_LOCOMOTION_REVERSE_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 124,
    "label": "QUADRUPED_BODY_ADJUST_DEFAULT",
    "name": "QUADRUPED_BODY_ADJUST_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 200,
    "label": "双足倒地起身",
    "name": "BIPED_RECOVERY",
    "remote_safe": false
  },
  {
    "id": 201,
    "label": "双足站立",
    "name": "BIPED_STAND_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 202,
    "label": "双足行走",
    "name": "BIPED_LOCOMOTION_DEFAULT",
    "remote_safe": true
  },
  {
    "id": 203,
    "label": "双足越障",
    "name": "BIPED_LOCOMOTION_TERRAIN",
    "remote_safe": false
  },
  {
    "id": 206,
    "label": "双足太空步",
    "name": "BIPED_LOCOMOTION_MOONWALK",
    "remote_safe": false
  },
  {
    "id": 207,
    "label": "双足奔跑",
    "name": "BIPED_LOCOMOTION_RUN",
    "remote_safe": false
  },
  {
    "id": 208,
    "label": "双足模仿",
    "name": "BIPED_MIMIC",
    "remote_safe": false
  },
  {
    "id": 300,
    "label": "双足全身控制（WBC）",
    "name": "BIPED_LOCOMOTION_WBC",
    "remote_safe": true
  },
  {
    "id": 301,
    "label": "双足动画",
    "name": "BIPED_LOCOMOTION_ANIMATION",
    "remote_safe": false
  },
  {
    "id": 302,
    "label": "双足上肢录制",
    "name": "BIPED_RECORD_UPPER",
    "remote_safe": false
  },
  {
    "id": 303,
    "label": "双足轨迹移动",
    "name": "BIPED_GIMBAL",
    "remote_safe": false
  },
  {
    "id": 304,
    "label": "BIPED_NPZ_MIMIC",
    "name": "BIPED_NPZ_MIMIC",
    "remote_safe": false
  },
  {
    "id": 305,
    "label": "BIPED_LOCOMOTION_WBCDANCE",
    "name": "BIPED_LOCOMOTION_WBCDANCE",
    "remote_safe": false
  },
  {
    "id": 1001,
    "label": "STORE_DEFAULT",
    "name": "STORE_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 1002,
    "label": "BIPED_WALK_RUN",
    "name": "BIPED_WALK_RUN",
    "remote_safe": false
  },
  {
    "id": 1003,
    "label": "MIMIC",
    "name": "MIMIC",
    "remote_safe": false
  },
  {
    "id": 1004,
    "label": "MIMIC_LINKCRAFT",
    "name": "MIMIC_LINKCRAFT",
    "remote_safe": false
  },
  {
    "id": 1005,
    "label": "BIPED_WHOLE_BODY_CTRL",
    "name": "BIPED_WHOLE_BODY_CTRL",
    "remote_safe": false
  },
  {
    "id": 1006,
    "label": "MIMIC_OPENSOURCE",
    "name": "MIMIC_OPENSOURCE",
    "remote_safe": false
  },
  {
    "id": 1007,
    "label": "STAND_UP",
    "name": "STAND_UP",
    "remote_safe": false
  },
  {
    "id": 1008,
    "label": "LYING_DEFAULT",
    "name": "LYING_DEFAULT",
    "remote_safe": false
  },
  {
    "id": 1009,
    "label": "LIE_FACE_DOWN",
    "name": "LIE_FACE_DOWN",
    "remote_safe": false
  },
  {
    "id": 1010,
    "label": "LIE_FACE_UP",
    "name": "LIE_FACE_UP",
    "remote_safe": false
  },
  {
    "id": 1011,
    "label": "BIPED_QUIET_WALK",
    "name": "BIPED_QUIET_WALK",
    "remote_safe": false
  },
  {
    "id": 1012,
    "label": "BIPED_BLIND_TERRAIN",
    "name": "BIPED_BLIND_TERRAIN",
    "remote_safe": false
  },
  {
    "id": 1013,
    "label": "BIPED_SIT_DOWN",
    "name": "BIPED_SIT_DOWN",
    "remote_safe": false
  },
  {
    "id": 1014,
    "label": "双足自定义上肢",
    "name": "BIPED_CUSTOM_UPPER",
    "remote_safe": true
  },
  {
    "id": 1015,
    "label": "BIPED_RUN",
    "name": "BIPED_RUN",
    "remote_safe": false
  },
  {
    "id": 1016,
    "label": "BIPED_TAKE_SEAT",
    "name": "BIPED_TAKE_SEAT",
    "remote_safe": false
  },
  {
    "id": 1017,
    "label": "BIPED_LEAVE_SEAT",
    "name": "BIPED_LEAVE_SEAT",
    "remote_safe": false
  },
  {
    "id": 1018,
    "label": "MIMIC_V2",
    "name": "MIMIC_V2",
    "remote_safe": false
  },
  {
    "id": 1019,
    "label": "MIMIC_OPENSOURCE_V2",
    "name": "MIMIC_OPENSOURCE_V2",
    "remote_safe": false
  }
];
/** 当前模式 → 可直接一步切到的远程白名单模式（厂商状态图） */
export const MODE_RULES: Readonly<Record<string, ReadonlyArray<string>>> = {
  "BIPED_CUSTOM_UPPER": [
    "BIPED_LOCOMOTION_WBC"
  ],
  "BIPED_LOCOMOTION_DEFAULT": [
    "BIPED_LOCOMOTION_WBC"
  ],
  "BIPED_LOCOMOTION_WBC": [
    "BIPED_LOCOMOTION_DEFAULT",
    "BIPED_CUSTOM_UPPER"
  ],
  "QUADRUPED_LOCOMOTION_DEFAULT": [
    "QUADRUPED_STAND_DEFAULT"
  ],
  "QUADRUPED_STAND_DEFAULT": [
    "QUADRUPED_LOCOMOTION_DEFAULT"
  ]
};
export const MODE_STATUS = {
  "RUNNING": 100,
  "TRANSITION": 200
} as const;
/** 姿态操作（变形、趴下、起立）：目标、允许的起点、最终停留的模式（变形是过渡状态）。要策略 posture_remote */
export const POSTURE_OPS: ReadonlyArray<{ name: string; label: string; from: ReadonlyArray<string>; settles: string }> = [
  {
    "from": [
      "BIPED_LOCOMOTION_WBC"
    ],
    "label": "变四足",
    "name": "BIPED_TO_QUADRUPED",
    "settles": "QUADRUPED_LOCOMOTION_DEFAULT"
  },
  {
    "from": [
      "QUADRUPED_LOCOMOTION_DEFAULT"
    ],
    "label": "变双足",
    "name": "QUADRUPED_TO_BIPED",
    "settles": "BIPED_LOCOMOTION_WBC"
  },
  {
    "from": [
      "QUADRUPED_STAND_DEFAULT",
      "QUADRUPED_LOCOMOTION_DEFAULT",
      "QUADRUPED_SIT_DOWN_DEFAULT",
      "PASSIVE_DEFAULT"
    ],
    "label": "趴下",
    "name": "QUADRUPED_GET_DOWN_DEFAULT",
    "settles": "QUADRUPED_GET_DOWN_DEFAULT"
  },
  {
    "from": [
      "QUADRUPED_GET_DOWN_DEFAULT",
      "QUADRUPED_SIT_DOWN_DEFAULT",
      "PASSIVE_DEFAULT"
    ],
    "label": "起立",
    "name": "QUADRUPED_STAND_DEFAULT",
    "settles": "QUADRUPED_STAND_DEFAULT"
  }
];
/** 机器人相机（ADR 0004）；`flip_biped` = 双足形态下画面倒置，控制台旋转 180° */
export const CAMERAS: ReadonlyArray<{ id: string; label: string; flip_biped: boolean }> = [
  {
    "flip_biped": true,
    "id": "head_stereo_left",
    "label": "头部左目"
  },
  {
    "flip_biped": true,
    "id": "head_stereo_right",
    "label": "头部右目"
  }
];
export const EMOTIONS: ReadonlyArray<{ id: number; label: string }> = [
  {
    "id": 10,
    "label": "平静 1"
  },
  {
    "id": 11,
    "label": "平静 2"
  },
  {
    "id": 12,
    "label": "平静 3"
  },
  {
    "id": 13,
    "label": "空表情"
  },
  {
    "id": 14,
    "label": "睁眼"
  },
  {
    "id": 15,
    "label": "闭眼"
  },
  {
    "id": 90,
    "label": "轻微喜悦 1"
  },
  {
    "id": 16,
    "label": "轻微喜悦 2"
  },
  {
    "id": 17,
    "label": "轻微喜悦 3"
  },
  {
    "id": 102,
    "label": "轻微喜悦 4"
  },
  {
    "id": 18,
    "label": "中等喜悦"
  },
  {
    "id": 19,
    "label": "非常喜悦"
  },
  {
    "id": 20,
    "label": "害怕"
  },
  {
    "id": 21,
    "label": "难过"
  },
  {
    "id": 22,
    "label": "四处看"
  },
  {
    "id": 23,
    "label": "黑屏"
  },
  {
    "id": 60,
    "label": "无聊"
  },
  {
    "id": 130,
    "label": "困惑"
  },
  {
    "id": 230,
    "label": "疲惫"
  },
  {
    "id": 240,
    "label": "自信"
  },
  {
    "id": 250,
    "label": "聆听"
  },
  {
    "id": 260,
    "label": "思考"
  },
  {
    "id": 270,
    "label": "说话"
  }
];
export const LED_MODES: ReadonlyArray<{ mode: number; label: string }> = [
  {
    "label": "熄灭",
    "mode": 0
  },
  {
    "label": "绿色流水",
    "mode": 1
  },
  {
    "label": "彩虹",
    "mode": 2
  },
  {
    "label": "律动",
    "mode": 3
  },
  {
    "label": "星光闪烁",
    "mode": 4
  },
  {
    "label": "尾部渐亮",
    "mode": 5
  },
  {
    "label": "尾部渐暗",
    "mode": 6
  },
  {
    "label": "白色填充",
    "mode": 16
  },
  {
    "label": "白色高亮",
    "mode": 17
  },
  {
    "label": "白色呼吸",
    "mode": 20
  },
  {
    "label": "自定义颜色·呼吸",
    "mode": 254
  },
  {
    "label": "自定义颜色·闪烁",
    "mode": 255
  }
];
export const TTS_LEVELS: ReadonlyArray<{ level: number; label: string }> = [
  {
    "label": "后台",
    "level": 1
  },
  {
    "label": "主动服务",
    "level": 2
  },
  {
    "label": "任务",
    "level": 4
  },
  {
    "label": "交互（默认）",
    "level": 6
  },
  {
    "label": "预警",
    "level": 8
  },
  {
    "label": "安全（最高）",
    "level": 10
  }
];
export const INTERACTION_LIMITS = {
  "EMOTION_MAX_IDS": 8,
  "EMOTION_MAX_LOOPS": 20,
  "LED_CUSTOM_BLINK": 255,
  "LED_CUSTOM_BREATH": 254,
  "LED_MAX_PERIOD_MS": 10000,
  "TTS_DEFAULT_LEVEL": 6
} as const;
/** 机器人侧 `status.reason` → 中文说明（回执被拒时显示） */
export const REASONS: Readonly<Record<number, string>> = {
  "0": "成功",
  "1": "开箱状态中",
  "10": "前方有障碍物",
  "11": "后方有障碍物",
  "12": "左方有障碍物",
  "13": "右方有障碍物",
  "14": "上方有障碍物",
  "15": "其他任务正在运行",
  "16": "机器人已经是目标状态",
  "17": "未找到相关动作",
  "18": "无可用技能列表",
  "19": "需要处于双足站立状态",
  "2": "开机自检中",
  "20": "当前动作不匹配，无法执行动画",
  "21": "动作在黑名单中",
  "22": "当前姿态下无法进行动作转移",
  "23": "无符合条件的技能",
  "24": "室内模式下暂不支持该动作",
  "25": "动作配置未就绪",
  "26": "当前机型不支持该功能",
  "27": "机器人正在起立",
  "28": "当前动画不可打断",
  "29": "当前动画 ID 无效",
  "3": "关机状态中",
  "30": "当前状态不满足变形/动作执行条件",
  "31": "与 App 断开连接",
  "32": "超出上限",
  "33": "机器人正在移动，请稍后再试",
  "34": "检测到跌落风险，无法执行动作",
  "35": "厂商云端断开连接，无法执行",
  "36": "网络异常，无法执行",
  "37": "系统状态不支持，无法执行",
  "38": "请求参数非法",
  "39": "机器人内部错误",
  "4": "当前形态不支持",
  "40": "任务未处于运行状态",
  "41": "机器人被牵手中，无法执行动作",
  "42": "当前有动作任务正在执行，无法执行动作",
  "43": "光照不足",
  "44": "姿态不匹配",
  "45": "使用地图失败",
  "46": "启动建图失败",
  "47": "当前存在其他任务",
  "48": "保存地图失败",
  "49": "未找到专座前点",
  "5": "低电量限制",
  "50": "当前没有可用地图",
  "51": "查询专座前点失败",
  "52": "系统处于急停中，无法执行",
  "53": "手柄或 App 摇杆控制中，无法执行",
  "6": "正在充电中",
  "7": "动作不在白名单",
  "8": "HDS 故障",
  "9": "当前模式不支持"
};
export const LIMITS = {
  "ACK_TIMEOUT_MS": 3000,
  "CONSOLE_MAX_SUBSCRIPTIONS": 200,
  "PROXIMITY_EDGE_BLIND_MS": 500,
  "PROXIMITY_LINK_STALE_MS": 1000,
  "PROXIMITY_MAX_POINTS": 64,
  "STREAM_PROXIMITY": "proximity",
  "TELEMETRY_INTERVAL_MS": 1000,
  "VELOCITY_TTL_MS": 400
} as const;
export const CLOSE_CODES = {
  "AUTH_FAILED": 4001,
  "BACKPRESSURE": 4008,
  "DEVICE_DISABLED": 4003,
  "GOING_AWAY": 1001,
  "HEARTBEAT_TIMEOUT": 4010,
  "OVERLOADED": 1013,
  "PROTOCOL_ERROR": 4002,
  "REPLACED": 4009
} as const;
